<template>
    <div class="invoice-parking flex-column">
        <div class="invoice-header flex align-center justify-between"></div>

        <date-picker @changeDate="getPickDate" :date.sync="query.finishTime" type="year-month" title="选择年月">
            <template #left>
                <!-- <div class="invoice-header-batch flex align-center" v-if="!isBatch" @click="isBatch = true">
                    <img src="@/assets/images/invocie/batch.png" alt="" />
                    <span>批量开票</span>
                </div> -->
                <!-- <van-checkbox v-model="checkAll" @click="checkAllChange" v-else> -->
                <van-checkbox v-model="checkAll" @click="checkAllChange">
                    <div class="invoice-header-left flex align-center">
                        <span style="color: #009af3">全选</span>
                        <!-- <div class="invoice-header-cancle flex align-center" @click.stop="isBatch = false">
                            <img src="@/assets/images/invocie/cancle.png" alt="" />
                            <span>取消</span>
                        </div> -->
                    </div>
                </van-checkbox>
                <div class="invoice-parking-site flex align-center">
                    <span class="text-cut invoice-parking-site-name" @click="changeParking">{{ query.parkName }}</span> <van-icon name="arrow-down" />
                </div>
            </template>
        </date-picker>
        <div class="invoice-content">
            <lazy-load-list ref="lazyLoadList" @getList="getList" :getData="initData" :description="'暂无可开票记录'" :query="query">
                <template v-slot="slotData">
                    <van-checkbox-group v-model="result" ref="invoiceCheckbox" @change="invoiceitemChange">
                        <div class="invoice-item" v-for="(item, index) in slotData.dataList" :key="index">
                            <div class="invoice-item-header flex align-center">
                                <!-- <van-checkbox :name="item.id" v-if="isBatch"></van-checkbox> -->
                                <van-checkbox :name="item.id"></van-checkbox>

                                <div class="invoice-item-header-content flex align-center justify-between">
                                    <p class="invoice-item-header-name">{{ item.parkName }}</p>
                                    <div class="invoice-item-header-right">
                                        <p class="invoice-item-money text-price">{{ item.realMoney }}</p>
                                        <p class="invoice-item-discount" v-if="item.couponMoney > 0">已优惠{{ item.couponMoney }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="parkingPay-carInfo-content">
                                <div class="carInfo-content-item flex align-center">
                                    <img class="carInfo-content-item1" src="@/assets/images/pay/parkingPay-long.png" alt="" />
                                    <p class="carInfo-content-item-title">驶入时间</p>
                                    <p class="carInfo-content-item-value">{{ item.inTime }}</p>
                                </div>
                                <div class="carInfo-content-item flex align-center">
                                    <img class="carInfo-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                                    <p class="carInfo-content-item-title">停车时长</p>
                                    <p class="carInfo-content-item-value" style="color: #009af3">{{ secondToMinute(item.parkTime) }}分钟</p>
                                </div>
                                <div class="carInfo-content-item flex align-center">
                                    <img class="carInfo-content-item1" src="@/assets/images/pay/parking-code.png" alt="" />
                                    <p class="carInfo-content-item-title">车牌号</p>
                                    <p class="carInfo-content-item-value">{{ item.plateNum }}</p>
                                </div>
                            </div>
                        </div>
                    </van-checkbox-group>
                </template>
            </lazy-load-list>
        </div>
        <!-- <div class="invoice-confirm" v-if="isBatch"> -->
        <div class="invoice-confirm">
            <van-button class="comfirm-btn" :disabled="result.length == 0" v-debounce="invoicing">开票</van-button>
        </div>

        <van-action-sheet v-model="showDatePick">
            <div class="content">
                <van-picker title="选择停车场" show-toolbar value-key="parkName" :columns="parkingList" @confirm="parkingOnConfirm" @cancel="parkingOnCancel" @change="parkingOnChange" />
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
import DatePicker from "@/components/base/datePicker/date-picker.vue";
import LazyLoadList from "@/components/base/lazyLoadList/lazy-load-list.vue";
import { selectAllOrderInvoice, listElectronicInvoicePark } from "@/api/index";
import { secondToMinute } from "@/libs/tools";
import { Picker } from "vant";
export default {
    name: "InvoiceParking",
    components: {
        DatePicker,
        LazyLoadList,
        "van-picker": Picker,
    },
    data() {
        return {
            checkAll: false,
            query: {
                finishTime: "",
                page: 0,
                pageSize: 10,
                orderType: 2,
                parkCode: "",
                parkName: "全部",
            },
            showDatePick: false,
            isBatch: false,
            result: [],
            dataList: [], //数组

            parkingList: [],
        };
    },
    mounted() {
        this.getParkingLot();
        // let that = this;
        // this.$refs.invoiceCheckbox.toggleAll(this.checkAll);

        // this.$nextTick(() => {
        //     console.log(this.$refs.lazyLoadList.list);
        // });
    },
    methods: {
        secondToMinute,

        getList(list) {
            this.result = list.map((item) => item.id);
        },
        //给子组件使用
        initData() {
            return selectAllOrderInvoice(this.query);
        },
        //获取可开票停车场
        getParkingLot() {
            let obj = {
                page: 1,
                pageSize: 10,
            };
            listElectronicInvoicePark(obj).then((res) => {
                this.parkingList = [...[{ parkName: "全部", parkCode: "" }], ...res.data.data];
            });
        },
        //唤起选择停车场界面
        changeParking() {
            this.showDatePick = true;
        },
        //全选
        checkAllChange() {
            this.$refs.invoiceCheckbox.toggleAll(this.checkAll);
        },
        // 时间选择搜索
        getPickDate(value) {
            this.showDatePick = false;
        },
        // 复选框组修改事件
        invoiceitemChange() {
            //父组件那不到子组件没返回的数据，通过ref获取
            if (this.$refs.lazyLoadList.list.length > 0 && this.result.length == this.$refs.lazyLoadList.list.length) {
                this.checkAll = true;
            } else {
                this.checkAll = false;
            }
        },
        //车场选择确认
        parkingOnConfirm(value) {
            this.query.parkCode = value.parkCode;
            this.query.parkName = value.parkName;
            this.showDatePick = false;
        },
        //车场选择取消
        parkingOnCancel() {
            this.showDatePick = false;
        },
        parkingOnChange(value) {},

        //开票
        invoicing() {
            let invoiceArr = this.$refs.lazyLoadList.list.filter((item) => this.result.includes(item.id));
            this.$router.push({ name: "InvoiceCreate", params: { invoiceArr: invoiceArr } });
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";

.comfirm-btn {
    color: #fff;
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
}
.invoice-parking {
    min-height: 100vh;
    .invoice-header {
        width: 750px;
        height: 90px;
        padding: 30px;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #fff;
        z-index: 99;
        .invoice-parking-site {
            margin-right: 10px;
            font-size: 24px;
            color: #666666;
            .invoice-parking-site-name {
                width: 137px;
                text-align: center;
            }
        }
        .invoice-date {
            font-size: 28px;
            color: #666666;

            i {
                margin: 0 4px;
            }
        }
        .invoice-header-cancle {
            margin-left: 30px;
            img {
                width: 32px;
                height: 32px;
                margin-right: 15px;
            }
        }
        .invoice-header-batch {
            margin-left: 30px;
            color: @main-color;
            img {
                width: 32px;
                height: 32px;
                margin-right: 15px;
            }
        }
    }
    .invoice-content {
        margin-top: 100px;
        padding-bottom: 140px;
        .invoice-item {
            margin-bottom: 10px;
            padding: 30px;
            background-color: #fff;

            .invoice-item-header {
                .invoice-item-header-content {
                    flex: 1;
                    border-bottom: 1px solid #dbdada33;
                    margin-left: 15px;
                    .invoice-item-header-name {
                        font-size: 28px;
                        color: #666666;
                        line-height: 48px;
                    }
                    .invoice-item-header-right {
                        .invoice-item-money {
                            font-size: 42px;
                            font-weight: bold;
                            text-align: right;
                            color: #009af3;
                        }
                        .invoice-item-discount {
                            font-size: 20px;
                            color: #999999;
                            line-height: 48px;
                            text-align: right;
                        }
                    }
                }
            }
            .parkingPay-carInfo-content {
                flex: 1;
                padding: 24px 0 0 0;
                .carInfo-content-header {
                    font-size: 32px;
                    font-weight: 500;
                    color: #212121;
                    margin-bottom: 30px;
                }

                .carInfo-content-item {
                    margin-bottom: 16px;

                    .carInfo-content-item1 {
                        width: 24px;
                        height: 24px;
                    }

                    .carInfo-content-item2 {
                        width: 24px;
                        height: 28px;
                    }

                    .carInfo-content-item-title {
                        margin-left: 17px;
                        vertical-align: top;
                    }

                    .carInfo-content-item-value {
                        margin-left: auto;
                        color: #666666;
                        img {
                            width: 192px;
                            height: 128px;
                        }
                    }
                }
            }
        }
    }
    .invoice-confirm {
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #fff;
        padding: 24px;
        margin-top: auto;
    }
}
</style>
